import { request } from '@/utils/request'

export const reqManagerLogin = async(query) => {
    return await request({
        url: '/utadmin/wibqfdjzqyhnmlcoqxuwmppitmorjknb',
        method: 'post',
        data: query
    });
};